/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the context for the currently loaded patient.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/*
 * Used to create a context.
 */
import * as React from 'react';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/*
 * Used to get access to backend types.
 */
import * as Dtos from '../api/dtos';

/*
 * Used to set default values for the context
 */


/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */

export const stringToEConsentUserType = (value?: string | null) => {
    if (!value) {
        return EConsentUserType.Unknown;
    }

    switch (value) {
        case "participant":
            return EConsentUserType.Participant;
        case "investigator":
            return EConsentUserType.Investigator;
        case "unknown":
            return EConsentUserType.Unknown;
        default:
            return EConsentUserType.Unknown;
    }
}
export const eConsentUserTypeToString = (value?: EConsentUserType | null) => {
    if (!value) {
        return EConsentUserType.Unknown;
    }

    switch (value) {
        case EConsentUserType.Participant:
            return "participant";
        case EConsentUserType.Investigator:
            return "investigator";
        case EConsentUserType.Unknown:
        default:
            return "unknown";
    }
}

export enum EConsentUserType {
    Participant = 1,
    Investigator = 2,
    Unknown = 3
}

export interface IEConsentContext {
    consentEvent: Dtos.ConsentEvent | null | undefined;
    consentForms: Dtos.IEConsentForm[] | null | undefined;
    investigators: { [index: string]: string; } | null | undefined;
    principalInvestigator: string | null | undefined;
    userType: EConsentUserType | null;
}

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const EConsentContext = React.createContext<IEConsentContext>({
    consentEvent: null,
    consentForms: [],
    investigators: null,
    principalInvestigator: null,
    userType: null
});

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default EConsentContext;